export function sticky()
{
	window.onscroll = function changeClass(){
		let scroll = window.pageYOffset | document.body.scrollTop;

		let HTheader = document.getElementById('main-header').offsetHeight;
		let HTlogo = document.getElementById('header-logo').offsetHeight;
		let HTheight = document.getElementById('header-top').offsetHeight;
		let NavBtnHeight = document.getElementById('header-nav').offsetHeight;

		if(scroll >= 1) {
			document.body.classList.add('sticky-logo');
		} else {
			document.body.classList.remove('sticky-logo');
		}

		if(scroll >= HTheader - HTlogo) {
			document.body.classList.add('logo-bg');
		} else {
			document.body.classList.remove('logo-bg');
		}

		if(scroll >= HTheight - NavBtnHeight) {
			document.body.classList.add('sticky-menu');
		} else {
			document.body.classList.remove('sticky-menu');
		}
	}
}
